import { useContext } from "react";
import ActivityLogTable from "../../components/ActivityLogTable";
import { useQueryAccountActivities } from "../../lib/activity-log";
import { AccountContext } from "./AccountInfo";

/**
 * Shows the loading state until the account is known, as the query's
 * `enabled: accountId > 0` does, and remounts the list per account (a React
 * `key`), so the entries read for one account are never shown under another.
 */
const AccountActivity = () => {
  const { account } = useContext(AccountContext);
  const accountId = account?.id ?? -1;

  return accountId > 0 ? (
    <AccountActivityOfAccount key={accountId} accountId={accountId} />
  ) : (
    <ActivityLogTable isLoading={true} isError={false} activities={[]} />
  );
};

const AccountActivityOfAccount = ({ accountId }: { accountId: number }) => {
  const { isPending, isError, data } = useQueryAccountActivities(accountId);

  return (
    <ActivityLogTable
      isLoading={isPending}
      isError={isError}
      activities={data?.data ?? []}
    />
  );
};

export default AccountActivity;
